export default "__VITE_ASSET__C7p7gPT6__"